// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__kUKhE {
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
}

.styles_sidebar__J-RYM {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 50vh;
}

@media screen and (max-width: 390px) {
  .styles_sidebar__J-RYM {
    justify-content: flex-start;
  }
  .styles_advertisement__Q-abG {
    margin-top: -10%;
  }
}
.styles_heading__EhQJG {
  font-family: "Poppins", sans-serif;
  font-size: 44px;
  font-weight: 700;
  color: #FEFEFE;
}

.styles_subheading__fwqCJ {
  max-width: 460px;
  width: 100%;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #E8ECEF;
  letter-spacing: -0.02em;
  margin-top: 0.75rem;
}

.styles_advertisement__Q-abG {
  width: 500px;
  height: 500px;
}

.styles_advertisementWrapper__n2i-H {
  width: 500px;
  height: 500px;
}

@media screen and (max-width: 1440px) {
  .styles_heading__EhQJG {
    font-size: 36px;
  }
  .styles_subheading__fwqCJ {
    font-size: 16px;
  }
}
@media screen and (max-width: 1024px) {
  .styles_advertisement__Q-abG {
    width: 250px;
    height: 250px;
  }
  .styles_heading__EhQJG {
    font-size: 24px;
  }
  .styles_subheading__fwqCJ {
    font-size: 14px;
  }
}
@media screen and (max-width: 640px) {
  .styles_wrapper__kUKhE {
    border-top-right-radius: 0;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  .styles_subheading__fwqCJ {
    max-width: 275px;
  }
  .styles_advertisement__Q-abG {
    width: 345px;
    height: 345px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdvertisementBanner/styles.module.scss","webpack://./src/constants/fonts.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAAF;;AAGA;EACE;IACE,2BAAA;EAAF;EAGA;IACE,gBAAA;EADF;AACF;AAIA;EACE,kCCzBQ;ED0BR,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,gBAAA;EACA,WAAA;EACA,gCChCM;EDiCN,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,YAAA;EACA,aAAA;AAFF;;AAKA;EACE,YAAA;EACA,aAAA;AAFF;;AAKA;EACE;IACE,eAAA;EAFF;EAKA;IACE,eAAA;EAHF;AACF;AAMA;EACE;IACE,YAAA;IACA,aAAA;EAJF;EAOA;IACE,eAAA;EALF;EAQA;IACE,eAAA;EANF;AACF;AASA;EACE;IACE,0BAAA;IACA,gCAAA;IACA,+BAAA;EAPF;EAUA;IACE,gBAAA;EARF;EAWA;IACE,YAAA;IACA,aAAA;EATF;AACF","sourcesContent":["@import 'constants/fonts.scss';\n\n.wrapper {\n  width: 100%;\n  background-image: url(\"./background.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100vh / 2);\n}\n\n@media screen and (max-width: 390px) {\n  .sidebar {\n    justify-content: flex-start;\n  }\n\n  .advertisement {\n    margin-top: -10%;\n  }\n}\n\n.heading {\n  font-family: $poppins;\n  font-size: 44px;\n  font-weight: 700;\n  color: #FEFEFE;\n}\n\n.subheading {\n  max-width: 460px;\n  width: 100%;\n  font-family: $inter;\n  font-size: 24px;\n  font-weight: 400;\n  color: #E8ECEF;\n  letter-spacing: -0.02em;\n  margin-top: .75rem;\n}\n\n.advertisement {\n  width: 500px;\n  height: 500px;\n}\n\n.advertisementWrapper {\n  width: 500px;\n  height: 500px;\n}\n\n@media screen and (max-width: 1440px) {\n  .heading {\n    font-size: 36px;\n  }\n\n  .subheading {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .advertisement {\n    width: 250px;\n    height: 250px;\n  }\n\n  .heading {\n    font-size: 24px;\n  }\n\n  .subheading {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .wrapper {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 12px;\n    border-bottom-left-radius: 12px;\n  }\n\n  .subheading {\n    max-width: 275px;\n  }\n\n  .advertisement {\n    width: 345px;\n    height: 345px;\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__kUKhE`,
	"sidebar": `styles_sidebar__J-RYM`,
	"advertisement": `styles_advertisement__Q-abG`,
	"heading": `styles_heading__EhQJG`,
	"subheading": `styles_subheading__fwqCJ`,
	"advertisementWrapper": `styles_advertisementWrapper__n2i-H`
};
export default ___CSS_LOADER_EXPORT___;
